// Patches Judge.me review widget elements that have no accessible names.
// Runs on initial load and watches for dynamically injected content.

(function () {
  function patchJudgeMeA11y(root) {
    // "Read full review" popup trigger links — completely empty, role=button
    root.querySelectorAll('.jdgm-popup-card__full-rev-link:not([aria-label])').forEach(function (el) {
      // Try to find reviewer name in the parent card for a meaningful label
      var card = el.closest('.jdgm-popup-card, .jdgm-rev');
      var reviewer = card && card.querySelector('.jdgm-rev__author, .jdgm-popup-card__author');
      var name = reviewer && reviewer.textContent.trim();
      el.setAttribute('aria-label', name ? 'Read full review by ' + name : 'Read full review');
    });

    // "View product reviews" links inside the expanded review panel — also empty
    root.querySelectorAll('.jdgm-full-rev__product-button:not([aria-label])').forEach(function (el) {
      var panel = el.closest('.jdgm-full-rev');
      var product = panel && panel.querySelector('.jdgm-full-rev__product-title, .jdgm-full-rev__header');
      var title = product && product.textContent.trim();
      el.setAttribute('aria-label', title ? 'View all reviews for ' + title : 'View all reviews for this product');
    });
  }

  // Patch whatever is already in the DOM
  patchJudgeMeA11y(document);

  // Watch for Judge.me injecting content dynamically (popups, lazy loads)
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          patchJudgeMeA11y(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
